export default __webpack_public_path__ + "static/media/Circular.ec71e565.woff";